export enum SttMarkerType {
  AutoGeneratedHearing = 'auto-generated-hearing',
  Event = 'event',
  Hearing = 'hearing',
  Sealing = 'sealing',
  Session = 'session',
}
